import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

interface GeocodeType{
  category_ids: number,
  min_wgs84lat: number,
  max_wgs84lat: number,
  min_wgs84lon: number,
  max_wgs84lon: number,
  valid_at: string,
  limit: number
}

// interface GeocodeItemType{
//   name: string;
//   wgs84_lat: number;
//   wgs84_lon: number
// }

// interface GeocodeResponseType{
//   query: string;
//   results: GeocodeItemType[]
// }

interface GeocodeResultType {
  features: [],
  type: string;
}
const useAreaPolygon = () => {
  return useMutation({
    mutationFn: async (
      query: GeocodeType
    ): Promise<GeocodeResultType | null> => {
      if (!query) return null;

      const params = new URLSearchParams({ ...query  }).toString();

      const URL = `${import.meta.env.VITE_API_AREA_POLYGON_URL}?${params}`;

      const { data } = await axiosClient.get<GeocodeResultType>(URL);
      return data;
    },
  });
};

export default useAreaPolygon;
export type {GeocodeType, GeocodeResultType}
